export default __webpack_public_path__ + "static/media/planning2.4c29e556.svg";